<template>
  <v-card flat>
    <v-card-title class="pa-1 pt-0 pb-1">
      <v-text-field solo dense hide-details ref="scanFocus" v-model="scanNumber" autocomplete="off"
        @change="getRespectiveProductOrder"
        :placeholder="$t('message.dashboard.scanText')"></v-text-field>
    </v-card-title>
    <v-card-title class="pa-0 pl-2 pr-2">
      <v-btn x-small fab @click="previousList" :disabled="page === 1">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <h5 class="mx-auto">{{ $t('message.dashboard.customerOrder') }}</h5>
      <span class="mr-3 mt-1 text-subtitle-2">{{ getPaginateData }}</span>
      <v-btn x-small fab @click="nextList" :disabled="hasNoNext">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pa-1 pt-0 mt-2">
      <div class="text-center" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <template v-for="(item, index) in listOfOrders">
        <order-item :key="index" :isList="true" :model="item"></order-item>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      listOfOrders: [],
      loading: false,
      page: 1,
      totalCount: 0,
      scanNumber: '',
      totalDbData: null,
      perPage: 20,
      hasNoNext: false
    }
  },
  components: {
    'order-item': () => import('@/components/Order/CustomerItem')
  },
  mounted () {
    requestAnimationFrame(() => {
      if (this.$refs.scanFocus) {
        this.$refs.scanFocus.focus()
      }
    })
    this.getOrders()
  },
  watch: {
    page (val) {
      this.getOrders()
    }
  },
  computed: {
    getPaginateData () {
      var showFrom = ((this.page - 1) * this.perPage) + 1
      var showTo = (showFrom - 1) + this.listOfOrders.length
      return this.totalDbData > 0 ? `${showFrom} - ${showTo} av ${this.totalDbData}` : ''
    }
  },
  methods: {
    getOrders () {
      this.loading = true
      let pageVal = this.page || 1
      let query = {
        'expand': [{
          'select': ['id', 'name'],
          'model': 'Customer',
          'on_field': 'id',
          'on_parent_field': 'customerid'
        }, {
          'select': ['id', 'name'],
          'model': 'CustomerShipment',
          'on_field': 'id',
          'on_parent_field': 'shipment'
        }],
        'skip': ((pageVal - 1) * this.perPage),
        'limit': this.perPage,
        'order_by': {
          'field': 'number',
          'asc_or_desc': 'desc'
        },
        'include_count': true,
        'filter': `storesales ne '1' AND state eq 'pick'`
      }
      this.$api.execute('post', 'orders/query', query)
        .then((response) => {
          if (response.data) {
            let { values, count } = response.data
            this.totalDbData = count
            values.map((x) => {
              x.customername = x.customer_name
              return x
            })
            this.totalCount = Math.ceil(count / this.perPage)
            if (this.page === this.totalCount) this.hasNoNext = true
            this.listOfOrders = values
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    previousList () {
      this.page--
      this.checkIsNextEnabled()
    },
    nextList () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.page++
        this.hasNoNext = false
      }
    },
    checkIsNextEnabled () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.hasNoNext = false
      }
    },
    getRespectiveProductOrder () {
      if (this.scanNumber) {
        this.$api.execute('get', `/orders/get_order_by_number/${this.scanNumber}`)
          .then((response) => {
            if (response && response.data && !response.data.storesales) {
              this.$router.push(`/customer_orders/${response.data.id}`)
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.order.noOrderFound') })
            }
          })
      }
    }
  }
}
</script>
